/* ==============================
   Compare Popup Mobile JavaScript
   独立的手机端JavaScript文件
   ============================== */

   (function() {
    'use strict';
    
    // 手机端弹窗管理器
    var MobileComparePopup = {
      // 初始化
      init: function() {
        this.bindEvents();
        this.preprocessPopupButtons();
      },
      
      // 绑定事件
      bindEvents: function() {
        var self = this;
        
         // 监听弹窗打开事件
         document.addEventListener('DOMContentLoaded', function() {
           // 延迟执行，确保所有内容都已加载
           setTimeout(function() {
             self.checkForComparePopups();
           }, 1000);
         });
        
        // 监听窗口大小变化
        window.addEventListener('resize', function() {
          self.handleResize();
        });
        
         // 监听弹窗内容变化
         var observer = new MutationObserver(function(mutations) {
           mutations.forEach(function(mutation) {
             if (mutation.type === 'childList') {
               // 延迟执行，避免频繁处理
               setTimeout(function() {
                 self.checkForComparePopups();
               }, 500);
             }
           });
         });
        
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      },
      
       // 处理窗口大小变化
       handleResize: function() {
         var self = this;
         
         // 延迟执行，避免频繁触发
         clearTimeout(this.resizeTimeout);
         this.resizeTimeout = setTimeout(function() {
           // 查找所有已处理的弹窗
           var processedPopups = document.querySelectorAll('.mobile-compare-processed');
           
           processedPopups.forEach(function(popup) {
             var comparisonTable = popup.querySelector('.comparison-table');
             
             if (comparisonTable) {
               if (window.innerWidth <= 768) {
                 // 切换到手机端
                 if (!popup.classList.contains('mobile-compare-popup')) {
                   self.initMobilePopup(popup, comparisonTable);
                 }
               } else {
                 // 切换到电脑端
                 if (popup.classList.contains('mobile-compare-popup')) {
                   self.restoreDesktopPopup(popup, comparisonTable);
                 }
               }
             }
           });
         }, 300);
       },
      
      // 恢复电脑端弹窗
      restoreDesktopPopup: function(popup, comparisonTable) {
        // 移除手机端类名
        popup.classList.remove('mobile-compare-popup');
        
        // 清除所有内联样式
        popup.style.cssText = '';
        
        // 立即强制隐藏所有手机端元素
        var mobileElements = popup.querySelectorAll('.mobile-compare-popup__content, .mobile-compare-popup__title, .mobile-compare-sku-selector, .mobile-compare-body, [class*="mobile-compare-params"]');
        mobileElements.forEach(function(element) {
          element.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; position: absolute !important; left: -9999px !important; top: -9999px !important; width: 0 !important; height: 0 !important; overflow: hidden !important;';
        });
        
        // 清理所有手机端内容
        this.cleanupMobileContent(popup);
        
        // 恢复原始内容区域的显示
        var contentArea = popup.querySelector('.popup-modal__content');
        if (contentArea) {
          contentArea.style.display = '';
          contentArea.style.visibility = '';
          contentArea.style.opacity = '';
          contentArea.style.position = '';
          contentArea.style.left = '';
          contentArea.style.top = '';
        }
        
        // 重新应用桌面端样式
        setTimeout(function() {
          var newTable = popup.querySelector('.comparison-table');
          if (newTable && window.applyStickyStyles) {
            window.applyStickyStyles(newTable);
          }
        }, 100);
      },
      
       // 检查并处理对比弹窗
       checkForComparePopups: function() {
         var self = this;
         
         // 查找所有可能的弹窗
         var popups = document.querySelectorAll('[class*="modal"], [class*="popup"], [class*="overlay"]');
         
         popups.forEach(function(popup) {
           // 检查是否包含对比表格
           var comparisonTable = popup.querySelector('.comparison-table');
           if (comparisonTable && !popup.classList.contains('mobile-compare-processed')) {
             // 标记为已处理
             popup.classList.add('mobile-compare-processed');
             
             // 只在手机端应用手机端样式
             if (window.innerWidth <= 768) {
               self.initMobilePopup(popup, comparisonTable);
             }
             // 电脑端保持原样，不做任何处理
           }
         });
       },
       
       // 预先处理弹窗按钮点击
       preprocessPopupButtons: function() {
         var self = this;
         
         // 查找所有可能的弹窗按钮
         var buttons = document.querySelectorAll('button, a, [class*="btn"], [class*="button"]');
         
         buttons.forEach(function(button) {
           // 检查按钮文本或属性是否包含对比相关关键词
          var buttonText = (button.textContent || '').toLowerCase();
          var buttonClass = (button.getAttribute('class') || '').toLowerCase();
          var buttonHref = (typeof button.href === 'string' ? button.href : '') || '';
           
           if (buttonText.includes('compare') || 
               buttonText.includes('对比') || 
               buttonClass.includes('compare') ||
               buttonHref.includes('compare')) {
             
             // 为按钮添加点击事件监听
             button.addEventListener('click', function(e) {
               // 如果是手机端，延迟检查弹窗
               if (window.innerWidth <= 768) {
                 setTimeout(function() {
                   self.checkForComparePopups();
                 }, 100);
               }
             });
           }
         });
       },
      
      // 初始化手机端弹窗
      initMobilePopup: function(popup, comparisonTable) {
        var self = this;
        
        // 先清理可能存在的手机端内容
        this.cleanupMobileContent(popup);
        
        // 保存原始表格（如果还没有保存）
        if (!comparisonTable.dataset.originalTable) {
          comparisonTable.dataset.originalTable = comparisonTable.outerHTML;
        }
        
        // 添加手机端类名，但不破坏原始结构
        popup.classList.add('mobile-compare-popup');
        
        // 应用手机端样式
        popup.style.cssText = 'position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background: rgba(0, 0, 0, 0.5) !important; display: flex !important; align-items: flex-end !important; justify-content: center !important; z-index: 9999 !important;';
        
        // 查找弹窗内容区域
        var contentArea = popup.querySelector('.popup-modal__content');
        if (contentArea) {
          // 隐藏原始内容
          contentArea.style.display = 'none !important';
          contentArea.style.visibility = 'hidden';
          contentArea.style.opacity = '0';
          contentArea.style.position = 'absolute';
          contentArea.style.left = '-9999px';
        }
        
        // 创建新的手机端内容
        var mobileContent = this.createMobileStructure(comparisonTable);
        
        // 将手机端内容添加到弹窗中
        popup.appendChild(mobileContent);
        
        // 绑定事件
        this.bindMobileEvents(popup, comparisonTable);
      },
      
      // 清理手机端内容
      cleanupMobileContent: function(popup) {
        // 查找所有手机端元素
        var mobileElements = popup.querySelectorAll('.mobile-compare-popup__content, .mobile-compare-popup__title, .mobile-compare-sku-selector, .mobile-compare-sku-list, .mobile-compare-sku-option, .mobile-compare-body, .mobile-compare-body__title, .mobile-compare-params, .mobile-compare-param-item, .mobile-compare-param-name, .mobile-compare-param-value, [class*="mobile-compare-params"]');
        
        // 先强制隐藏所有元素
        mobileElements.forEach(function(element) {
          element.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; position: absolute !important; left: -9999px !important; top: -9999px !important; width: 0 !important; height: 0 !important; overflow: hidden !important;';
        });
        
        // 延迟移除元素，确保隐藏效果生效
        setTimeout(function() {
          mobileElements.forEach(function(element) {
            if (element && element.parentNode) {
              element.remove();
            }
          });
        }, 50);
      },
      
      // 创建手机端结构
      createMobileStructure: function(comparisonTable) {
        var self = this;
        
        // 提取产品信息
        var products = this.extractProducts(comparisonTable);
        
        // 创建主容器
        var container = document.createElement('div');
        container.className = 'mobile-compare-popup__content';
        
        // 创建标题
        var title = document.createElement('div');
        title.className = 'mobile-compare-popup__title';
        title.textContent = 'Compare Options';
        container.appendChild(title);
        
        // 创建SKU选择器
        var skuSelector = this.createSkuSelector(products);
        container.appendChild(skuSelector);
        
        // 创建内容区域
        var contentArea = this.createContentArea(comparisonTable, products);
        container.appendChild(contentArea);
        
        return container;
      },
      
      // 提取产品信息
      extractProducts: function(comparisonTable) {
        var products = [];
        
        // 从表头提取产品名称
        var headerRow = comparisonTable.querySelector('.table-row.header');
        if (headerRow) {
          var cells = headerRow.querySelectorAll('.cell');
          for (var i = 1; i < cells.length; i++) {
            var productName = cells[i].textContent.trim();
            if (productName && productName !== 'What\'s Included') {
              products.push({
                name: productName,
                price: this.extractPrice(comparisonTable, i)
              });
            }
          }
        }
        
        // 如果没有找到产品，使用默认值
        if (products.length === 0) {
          products = [
            { name: 'DJI Air 3S (DJI RC-N3)', price: 'USD $1,099' },
            { name: 'DJI Air 3S Fly More Combo (DJI RC-N3)', price: 'USD $1,399' },
            { name: 'DJI Air 3S Fly More Combo (DJI RC 2)', price: 'USD $1,599' }
          ];
        }
        
        return products;
      },
      
      // 提取价格
      extractPrice: function(comparisonTable, productIndex) {
        var priceRow = comparisonTable.querySelector('.table-row:nth-child(3)');
        if (priceRow) {
          var priceCells = priceRow.querySelectorAll('.cell');
          if (priceCells[productIndex]) {
            // 直接返回innerHTML，保留HTML结构（包括<span class="price-original">）
            var priceHTML = priceCells[productIndex].innerHTML.trim();
            if (priceHTML && priceHTML !== '-') {
              return priceHTML;
            }
          }
        }
        return 'USD $0';
      },
      
      // 创建SKU选择器
      createSkuSelector: function(products) {
        var selector = document.createElement('div');
        selector.className = 'mobile-compare-sku-selector';
        
        var list = document.createElement('div');
        list.className = 'mobile-compare-sku-list';
        
        products.forEach(function(product, index) {
          var option = document.createElement('div');
          option.className = 'mobile-compare-sku-option';
          if (index === 0) option.classList.add('active');
          option.setAttribute('data-product-index', index);
          
          var name = document.createElement('div');
          name.className = 'sku-name';
          name.textContent = product.name;
          
          var price = document.createElement('div');
          price.className = 'sku-price';
          // 使用innerHTML保留HTML结构（包括<span class="price-original">）
          price.innerHTML = product.price;
          
          option.appendChild(name);
          option.appendChild(price);
          list.appendChild(option);
        });
        
        selector.appendChild(list);
        return selector;
      },
      
      // 创建内容区域
      createContentArea: function(comparisonTable, products) {
        var contentArea = document.createElement('div');
        contentArea.className = 'mobile-compare-body';
        
        // 创建标题
        var title = document.createElement('div');
        title.className = 'mobile-compare-body__title';
        title.textContent = 'In the Box';
        contentArea.appendChild(title);
        
        // 创建参数列表
        var paramsList = this.createParamsList(comparisonTable, products);
        contentArea.appendChild(paramsList);
        
        return contentArea;
      },
      
      // 创建参数列表
      createParamsList: function(comparisonTable, products) {
        var self = this;
        var paramsContainer = document.createElement('div');
        paramsContainer.className = 'mobile-compare-params';
        
        // 提取参数行（跳过表头、图片行、价格行）
        var rows = comparisonTable.querySelectorAll('.table-row:not(.header)');
        var paramRows = [];
        
        for (var i = 2; i < rows.length; i++) { // 跳过前两行（图片和价格）
          paramRows.push(rows[i]);
        }
        
        // 为每个产品创建参数列表
        products.forEach(function(product, productIndex) {
          var productParams = document.createElement('div');
          productParams.className = 'mobile-compare-params-' + productIndex;
          productParams.style.display = productIndex === 0 ? 'block' : 'none';
          
          paramRows.forEach(function(row) {
            var cells = row.querySelectorAll('.cell');
            if (cells.length > productIndex + 1) {
              var paramItem = self.createParamItem(cells[0], cells[productIndex + 1]);
              productParams.appendChild(paramItem);
            }
          });
          
          paramsContainer.appendChild(productParams);
        });
        
        return paramsContainer;
      },
      
      // 创建参数项
      createParamItem: function(nameCell, valueCell) {
        var item = document.createElement('div');
        item.className = 'mobile-compare-param-item';
        
        var name = document.createElement('div');
        name.className = 'mobile-compare-param-name';
        name.innerHTML = nameCell.innerHTML;
        
        var value = document.createElement('div');
        value.className = 'mobile-compare-param-value';
        value.textContent = valueCell.textContent.trim();
        
        item.appendChild(name);
        item.appendChild(value);
        
        return item;
      },
      
      // 绑定手机端事件
      bindMobileEvents: function(popup, comparisonTable) {
        var self = this;
        
        // SKU选择器点击事件
        var skuOptions = popup.querySelectorAll('.mobile-compare-sku-option');
        var paramContainers = popup.querySelectorAll('[class*="mobile-compare-params-"]');
        
        skuOptions.forEach(function(option, index) {
          option.addEventListener('click', function() {
            // 移除所有active类
            skuOptions.forEach(function(opt) {
              opt.classList.remove('active');
            });
            
            // 添加active类
            option.classList.add('active');
            
            // 显示对应的参数列表
            paramContainers.forEach(function(container, containerIndex) {
              container.style.display = containerIndex === index ? 'block' : 'none';
            });
            
            // 智能居中滚动SKU选项
            self.centerSelectedSkuOption(option);
          });
        });
        
        // 添加关闭功能
        this.addCloseFunctionality(popup);
      },
      
      // 智能居中滚动SKU选项
      centerSelectedSkuOption: function(selectedOption) {
        // 只在移动端执行
        if (window.innerWidth > 768) return;
        
        var skuSelector = selectedOption.closest('.mobile-compare-sku-selector');
        if (!skuSelector) return;
        
        // 检查是否是第一个按钮
        var allOptions = skuSelector.querySelectorAll('.mobile-compare-sku-option');
        var isFirstOption = selectedOption === allOptions[0];
        
        if (isFirstOption) {
          // 第一个按钮：滚动到最左边，确保完整显示
          skuSelector.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
          return;
        }
        
        // 其他按钮：智能居中
        var containerWidth = skuSelector.offsetWidth;
        var optionOffsetLeft = selectedOption.offsetLeft;
        var optionWidth = selectedOption.offsetWidth;
        
        // 计算按钮在容器中的实际位置
        var optionCenterInContainer = optionOffsetLeft + (optionWidth / 2);
        
        // 计算滚动位置，让按钮居中，但左右都显示部分按钮
        var scrollLeft = optionCenterInContainer - (containerWidth / 2);
        
        // 确保不会滚动到负值或超出范围
        var maxScrollLeft = skuSelector.scrollWidth - containerWidth;
        scrollLeft = Math.max(0, Math.min(scrollLeft, maxScrollLeft));
        
        // 平滑滚动到计算位置
        skuSelector.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      },
      
      // 添加关闭功能
      addCloseFunctionality: function(popup) {
        var self = this;
        var touchStartY = 0;
        var touchEndY = 0;
        var minSwipeDistance = 100;
        
        // 关闭弹窗的通用方法
        function closePopup() {
          // 方法1: 查找并点击原生关闭按钮（最温和的方法）
          var closeBtn = popup.querySelector('.popup-modal__toggle, [aria-label*="close"], [aria-label*="Close"]');
          if (closeBtn) {
            closeBtn.click();
            return; // 如果找到原生按钮，只使用它，不执行其他方法
          }
          
          // 方法2: 如果没有原生按钮，使用温和的关闭方法
          popup.removeAttribute('open');
          popup.classList.add('popup-modal--closing');
          popup.style.display = 'none';
          
          // 方法3: 延迟后恢复弹窗状态，确保可以再次打开
          setTimeout(function() {
            // 移除我们添加的手机端类名和样式
            popup.classList.remove('mobile-compare-popup');
            popup.classList.remove('mobile-compare-processed');
            popup.classList.remove('popup-modal--closing');
            popup.style.cssText = ''; // 清除所有内联样式
            
            // 恢复原始内容区域的显示
            var contentArea = popup.querySelector('.popup-modal__content');
            if (contentArea) {
              contentArea.style.display = '';
            }
            
            // 清理所有手机端内容
            self.cleanupMobileContent(popup);
            
            // 移除我们添加的关闭按钮
            var closeButton = popup.querySelector('button[style*="position: absolute"]');
            if (closeButton) {
              closeButton.remove();
            }
          }, 300);
        }
        
        // 1. 点击外部关闭
        popup.addEventListener('click', function(e) {
          if (e.target === popup) {
            closePopup();
          }
        });
        
        // 2. 拖拽关闭
        popup.addEventListener('touchstart', function(e) {
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        
        popup.addEventListener('touchend', function(e) {
          touchEndY = e.changedTouches[0].clientY;
          var swipeDistance = touchEndY - touchStartY;
          
          if (swipeDistance > minSwipeDistance) {
            closePopup();
          }
        }, { passive: true });
        
        // 关闭按钮已移除
      }
    };
    
    // 初始化
    MobileComparePopup.init();
    
  })();
  